import { array, object, string } from 'yup'

export type PlatformRequest = {
	sender: PlatformRequestSender | null
	recipients: PlatformRequestReceiver[]
	subject: string
	content: string
	files: PlatformRequestAttachment[]
	includeLink: boolean
	protocolToHubspot: boolean
}

export function NewPlatformRequest() {
	return {
		sender: null,
		recipients: [],
		subject: '',
		content: '',
		files: [],
		includeLink: true,
		protocolToHubspot: true
	}
}

export type PlatformRequestSender = {
	id: string
	salutation: string
	firstname: string
	lastname: string
	email: string
}

export type PlatformRequestReceiver = {
	id?: string
	salutation?: string
	firstname?: string
	lastname?: string
	email: string
	type: PlatformRequestPopUserType
}

export type PlatformRequestAttachment = {
	id: string
	filename: string
	date: string // ISO date string, e.g. 2026-06-01
	size: number
	attached: boolean
}

export type PlatformRequestLastSend = {
	timestamp: string
	type: PlatformRequestLastSendType
}

export type PlatformRequestSendResponse = {
	type: PlatformRequestSendErrorType
	message?: string
	emails?: string[]
}

export enum PlatformRequestSendErrorType {
	GENERAL = 'GENERAL',
	FILES_NOT_IDENTICAL = 'FILES_NOT_IDENTICAL',
	EMAIL_SEND_ERROR = 'EMAIL_SEND_ERROR',
	SUCCESS = 'SUCCESS'
}

export enum PlatformRequestPopUserType {
	CONTACT = 'CONTACT',
	USER = 'USER'
}

enum PlatformRequestLastSendType {
	WITH_LINK = 'WITH_LINK',
	PARTIALLY_WITH_LINK = 'PARTIALLY_WITH_LINK',
	PARTIALLY_WITHOUT_LINK = 'PARTIALLY_WITHOUT_LINK',
	WITHOUT_LINK = 'WITHOUT_LINK'
}

export const PFR_LAST_SEND_WITH_TYPES = [
	PlatformRequestLastSendType.WITH_LINK,
	PlatformRequestLastSendType.PARTIALLY_WITH_LINK
]

/**
 * Validation
 */
// We use keys here, because the i18n translation is unfortunately loaded after this has been initialized.
export const platformRequestSchema = object({
	recipients: array()
		.ensure()
		.min(1, 'UI.PlatformRequests.validation.recipients.min')
		.of(object({ email: string().email('UI.PlatformRequests.validation.recipients.email') })),
	subject: string().required('UI.PlatformRequests.validation.subject.required'),
	content: string().required('UI.PlatformRequests.validation.content.required')
})
